<!-- Send Inquiry Reply Modal -->
<div class="modal fade" id="kt_modal_send_inquiry_reply" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Send Reply</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="replyForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <!-- Inquiry Information -->
          <div class="card mb-5" *ngIf="selectedInquiry">
            <div class="card-header">
              <h3 class="card-title">Replying to Inquiry</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <strong>Customer:</strong> {{ selectedInquiry.name || '-' }}
                </div>
                <div class="col-md-6">
                  <strong>Email:</strong> {{ selectedInquiry.email || '-' }}
                </div>
                <div class="col-md-12 mt-2">
                  <strong>Original Message:</strong> {{ selectedInquiry.message || '-' }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Select Message Dropdown -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Select Message</label>
              <select class="form-select" formControlName="select_message">
                <option value="">Select a message type</option>
                <option *ngFor="let option of messageOptions" [value]="option.value">{{ option.label }}</option>
              </select>
              <div *ngIf="select_message?.invalid && select_message?.touched" class="invalid-feedback d-block">
                <div *ngIf="select_message?.errors?.['required']">Please select a message type</div>
              </div>
            </div>

            <!-- Subject -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Subject</label>
              <input type="text"
                     class="form-control form-control-solid"
                     formControlName="subject"
                     placeholder="Enter subject">
              <div *ngIf="subject?.invalid && subject?.touched" class="invalid-feedback d-block">
                <div *ngIf="subject?.errors?.['required']">Subject is required</div>
                <div *ngIf="subject?.errors?.['minlength']">Subject must be at least 3 characters long</div>
              </div>
            </div>

            <!-- Message (Rich Text Editor) -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Message</label>
              <app-rich-text-editor
                formControlName="message"
                placeholder="Enter your reply message..."
                height="300px">
              </app-rich-text-editor>
              <div *ngIf="message?.invalid && message?.touched" class="invalid-feedback d-block">
                <div *ngIf="message?.errors?.['required']">Message is required</div>
              </div>
            </div>

            <!-- File Upload -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Attachment</label>

              <!-- File Input -->
              <div class="mb-3" *ngIf="!uploadedFileUrl">
                <input
                  type="file"
                  #fileInput
                  class="form-control form-control-solid"
                  accept="image/*,.pdf,.doc,.docx"
                  (change)="onFileSelected($event)"
                  [disabled]="isUploading"
                />
                <div class="form-text">Select a file (Images, PDF, DOC, DOCX)</div>
              </div>

              <!-- Upload Progress -->
              <div *ngIf="isUploading" class="d-flex align-items-center mb-3">
                <div class="spinner-border spinner-border-sm me-2" role="status">
                  <span class="visually-hidden">Uploading...</span>
                </div>
                <span class="text-muted">Uploading file...</span>
              </div>

              <!-- Uploaded File Display -->
              <div *ngIf="uploadedFileUrl && selectedFile" class="border rounded p-3 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="ki-duotone ki-file fs-2 text-primary me-3">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  <div>
                    <div class="fw-semibold">{{ selectedFile.name }}</div>
                    <div class="text-muted fs-7">{{ formatFileSize(selectedFile.size) }}</div>
                  </div>
                </div>
                <button type="button" class="btn btn-sm btn-icon btn-light-danger" (click)="removeFile()">
                  <i class="ki-duotone ki-cross fs-4">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button type="submit"
                  class="btn btn-primary"
                  [disabled]="isLoading">
            <span *ngIf="!isLoading">Send Reply</span>
            <span *ngIf="isLoading" class="d-flex align-items-center">
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Please wait...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
